<template>
  <el-dialog :visible.sync="hasShow" width="1000px" :before-close="hide" :lock-scroll="true"
    :close-on-click-modal="false" class="cashier-desk">
    <template #title>
      <div class="header">有看投，让投资大有看头</div>
    </template>
    <div v-if="goodsList">
      <!-- 商品信息 -->
      <div class="goods-wrapper wrapper">
        <div class="title">{{ goodsTitle }}</div>
        <div class="goods-item">
          <div class="name">{{ goodsNameTitle }}</div>
          <div class="goods-name">{{ goodsName }}</div>
        </div>
        <div class="goods-item">
          <div class="name">{{ goodsListTitle }}</div>
          <ul class="row">
            <li v-for="(item, index) in goodsList" :key="item.id" class="col" :class="{ active: activeIndex === index }"
              @click="changeGoods(index)">
              <slot name="goods" :goods-item="item"></slot>
            </li>
          </ul>
        </div>
      </div>

      <!-- 支付方式 -->
      <div class="wrapper">
        <div class="title">支付方式</div>
        <ul class="row payment-mode-list">
          <li v-for="(item, index) in paymentMethodList" :key="item.id" class="col"
            :class="{ active: activePayMethodIndex === index }" @click="changePayMethod(index)">
            <img :src="item.icon" alt />
            <div class="set-name">
              {{ item.name }}
              <template v-if="item.method === PaymentMethods.caiBi">
                （
                <span class>{{ balance }}</span>）
              </template>
            </div>
          </li>
        </ul>
      </div>

      <!-- 商品说明 -->
      <div v-if="saleRemark || saleRemarkAppend" class="wrapper">
        <!-- 说明 -->
        <ul v-if="saleRemark" class="service-list">
          <li v-for="(item, index) in saleRemark" :key="index" class="service-item"
            :class="index === 0 ? 'service-title' : ''">
            {{ item }}
          </li>
        </ul>

        <!-- 附加说明 -->
        <ul v-if="saleRemarkAppend" class="note-list">
          <li v-for="(item, index) in saleRemarkAppend" :key="index" class="note-item">
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- 底部 -->
      <footer class="footer">
        实付：
        <div class="price">
          <span class="symbol">￥</span>
          {{ activeProduct.price || activeProduct.value }}
        </div>
        <el-button type="danger" class="button-pay" @click="createOrder" :disabled="payButtonDisabled"
          :loading="loading">立即支付</el-button>
      </footer>
    </div>
  </el-dialog>
</template>

<script>
import { PaymentMethods } from '@/constant/PaymentMethods'

const PaymentMethodsList = new Map([
  [
    PaymentMethods.weXin,
    {
      method: PaymentMethods.weXin,
      name: '微信支付',
      tradeType: 3, // 扫码支付
      icon: require('@/assets/images/cashier-desk/wechat.png')
    }
  ],
  [
    PaymentMethods.aliPay,
    {
      method: PaymentMethods.aliPay,
      name: '支付宝',
      tradeType: 6, // PC支付
      icon: require('@/assets/images/cashier-desk/alipay.png')
    }
  ],
  [
    PaymentMethods.basepayWei,
    {
      method: PaymentMethods.basepayWei,
      name: '微信',
      tradeType: 11, // 扫码支付
      icon: require('@/assets/images/cashier-desk/wechat.png')
    }
  ],
  [
    PaymentMethods.BasepayAli,
    {
      method: PaymentMethods.BasepayAli,
      name: '支付宝',
      tradeType: 8, // PC支付
      icon: require('@/assets/images/cashier-desk/alipay.png')
    }
  ],
  [
    PaymentMethods.caiBi,
    {
      method: PaymentMethods.caiBi,
      name: '财币',
      icon: require('@/assets/images/cashier-desk/caibi.png')
    }
  ]
])

export default {
  name: 'BaseGoodsAction',
  props: [
    'value',
    'goodsInfo',
    'goodsTitle',
    'goodsNameTitle',
    'goodsName',
    'goodsListTitle',
    'goodsList',
    'saleRemark',
    'saleRemarkAppend',
    'payments',
    'price',
    'balance',
    'loading'
  ],
  data() {
    return {
      PaymentMethods,
      goods: {
        goodsId: '',
        setId: '',
        orderId: ''
      },
      /**
       * 当前选择的商品索引
       */
      activeIndex: 0,
      activePayMethodIndex: 0,
      /**
       * 是否已选择购买协议
       */
      hasAgreementSelected: true,
      /**
       * 是否显示支付动作面板弹框
       */
      hasPayActionSheet: false,
      /**
       * 订单信息
       * @type {OrderInfo}
       */
      orderInfo: null,
      /**
       * 正在创建订单
       */
      createOrderLoading: false,
      PaymentMethodsList
    }
  },
  computed: {
    hasShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    activeProduct() {
      return this.goodsList && this.goodsList[this.activeIndex]
    },
    payMethod() {
      return this.paymentMethodList[this.activePayMethodIndex].method
    },
    tradeType() {
      return this.paymentMethodList[this.activePayMethodIndex].tradeType
    },
    paymentMethodList() {
      const methodList = []

      this.payments &&
        this.payments.forEach(payMethod => {
          const methodItem = PaymentMethodsList.get(payMethod)
          if (
            methodItem.method === PaymentMethods.caiBi &&
            this.balance < this.price
          ) {
            methodItem.class = 'payment-mode--disable'
          }

          methodList.push(methodItem)
        })

      return methodList
    },
    /**
     * 是否禁用支付按钮
     * 1. 选择财币支付
     * 2. 财币余额不足
     */
    payButtonDisabled() {
      return (
        this.payMethod === PaymentMethods.caiBi &&
        this.activeProduct &&
        this.balance < this.price
      )
    }
  },
  methods: {
    hide() {
      this.hasShow = false
    },
    /**
     * 切换商品
     */
    changeGoods(index) {
      this.activeIndex = index
    },
    changePayMethod(index) {
      this.activePayMethodIndex = index
    },
    createOrder() {
      this.$emit('pay', {
        ...this.activeProduct,
        payMethod: this.payMethod,
        tradeType: this.tradeType
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cashier-desk {
  display: flex;
  align-items: center;

  ::v-deep {
    .el-dialog {}

    .el-dialog__header {
      padding-bottom: 0;
    }
  }
}

.header {
  margin: 10px 0 0;
  padding-top: 64px;
  font-size: 16px;
  color: #858585;
  text-align: center;
  background: url('~@/assets/images/common/logo.png') no-repeat top;
  background-size: 52px auto;
}

$wrapper-width: 792px;

.wrapper {
  width: $wrapper-width;
  margin: 0 auto 20px;
  background-color: #fafbfc;
  border: solid 1px #ebebeb;
  padding: 10px 20px 0;
}

.goods-wrapper {
  border-top: 6px solid #046bcc;
}

.title {
  padding-top: 6px;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #262626;
}

.goods-item {
  display: flex;

  &:last-child {
    padding-top: 20px;
  }

  .name {
    flex: 0 0 100px;
    font-size: 16px;
    color: #858585;
  }

  .goods-name {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: auto;

  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 0 0 160px;
    height: 70px;
    background-color: #ffffff;
    border-radius: 5px;
    border: solid 1px #ebebeb;
    padding: 0 10px;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;

    &.active {
      position: relative;
      border-color: #046bcc;
      background-image: linear-gradient(-45deg,
          #046bcc 0,
          #046bcc 15px,
          #ffffff 17px,
          #ffffff 100%);

      &::after {
        content: '';
        position: absolute;
        right: 2px;
        bottom: 5px;
        width: 10px;
        height: 6px;
        border-left: 2px solid #ffffff;
        border-bottom: 2px solid #ffffff;
        box-sizing: border-box;
        transform: rotate(-45deg);
      }
    }

    .set-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      color: #262626;
      line-height: 1;

      span {
        color: #046bcc;
      }
    }

    .price {
      padding-top: 12px;
      font-size: 20px;
      color: #e64c2e;
      line-height: 1;

      .symbol {
        font-size: 16px;
      }
    }
  }
}

.payment-mode-list {
  margin-left: 100px;
  // padding-bottom: 20px;

  .col {
    flex-direction: row;
  }

  img {
    width: 38px;
    margin-right: 16px;
  }
}

.service-list {
  font-size: 16px;
  color: #262626;
  line-height: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.note-list {
  font-size: 16px;
  color: #858585;
  line-height: 24px;
  padding-bottom: 10px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px auto 0;
  width: $wrapper-width;
  height: 80px;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  .price {
    font-size: 20px;
    color: #e64c2e;
    line-height: 1;

    .symbol {
      font-size: 16px;
    }
  }

  .button-pay {
    width: 160px;
    height: 48px;
    margin: 0 30px;
    background-color: #e64c2e;
    border-radius: 24px;
    font-size: 16px;
  }
}
</style>
